import { render } from "./IntakeStation.vue?vue&type=template&id=4a7ae35a&scoped=true"
import script from "./IntakeStation.vue?vue&type=script&lang=js"
export * from "./IntakeStation.vue?vue&type=script&lang=js"

import "./IntakeStation.vue?vue&type=style&index=0&id=4a7ae35a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7ae35a"]])

export default __exports__